// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"34751d273cc1a33ccaab","691":"1cd2d0a98aaa6de20209"}[chunkId] + ".js";
};